import { getStore, setStore } from '@/utils/store.js';


import api from '@/api/index.js';
export default ({

    state: {
        merchantAccessToken: getStore('merchantAccessToken'),
        merchantRefreshToken: getStore('merchantRefreshToken'),
        myStore: getStore('myStore'),
        myStoreCur: getStore('myStoreCur'),
        globalConfig: getStore('globalConfig'),
        temporaryAccessToken: getStore('temporaryAccessToken'),
        temporaryRefreshToken: getStore('temporaryRefreshToken'),
        synchro: getStore('synchro'),
    },
    getters: {

    },

    mutations: {
        getSynchro(that, val) {
            that.synchro = val
            setStore('synchro', val)
        },
        myStoreCur(that, val) {
            that.myStoreCur = val
            setStore('myStoreCur', val);
        },
        updateAccessToken(that, res) {
            that.merchantAccessToken = res;
            setStore('merchantAccessToken', res);
        },
        updateRefreshToken(that, res) {
            that.merchantRefreshToken = res;
            setStore('merchantRefreshToken', res);
        },
        udAccessToken(that, res) {
            that.temporaryAccessToken = res;
            setStore('temporaryAccessToken', res);
        },
        udRefreshToken(that, res) {
            that.temporaryRefreshToken = res;
            setStore('temporaryRefreshToken', res);
        },
        myStore(that, res) {
            that.myStore = res
            setStore('myStore', res);
        },
        globalConfig(that, res) {
            that.globalConfig = res
            setStore('globalConfig', res);
        },

    },

    actions: {
        setTemporary(that, res) {
            that.commit('udAccessToken', res.accessToken);
            that.commit('udRefreshToken', res.refreshToken);
        },
        setToken(that, res) {

            that.commit('updateAccessToken', res.accessToken);
            that.commit('updateRefreshToken', res.refreshToken);
        },
        stateClear(that) {
            that.commit('updateAccessToken', null);
            that.commit('updateRefreshToken', null);
            that.commit('myStore', null);
            that.commit('myStoreCur', null);
        },
        temporaryClear(that) {
            that.commit('udAccessToken', null);
            that.commit('udRefreshToken', null);
            that.commit('getSynchro', null);

        },
        async dynamicConfig() {
            const res = await api.dynamicConfig()
            return res
        }
    },
    modules: {}
})